import { Cookies } from 'react-cookie';

import { COOKEY_KEY, COOKEY_OPTION } from 'constants/cookieConstants';

const cookies = new Cookies();

export const setCookie = (name: string, value: string, option?: any) => {
  return cookies.set(name, value, { ...option });
};

export const getCookie = (name: string) => {
  return cookies.get(name);
};

export const removeCookie = (name: string, option?: any) => {
  return cookies.remove(name, option);
};

export const createCookieOption = () => {
  const date = new Date();
  const isDevServer = window.location.host === 'localhost:3000';

  return {
    expires: new Date(date.getTime() + COOKEY_OPTION.EXPIRES_TIME),
    path: '/',
    ...(!isDevServer && {
      domain: `.${COOKEY_OPTION.DOMAIN}`,
      secure: true,
    }),
  };
};

interface SetCookieTokenParams {
  accessToken: string;
  refreshToken: string;
}

export const setCookieToken = ({ accessToken, refreshToken }: SetCookieTokenParams) => {
  setCookie(COOKEY_KEY.ACCESS_TOKEN, accessToken, {
    ...createCookieOption(),
  });
  setCookie(COOKEY_KEY.REFRESH_TOKEN, refreshToken, {
    ...createCookieOption(),
  });
};

export const removeCookieToken = () => {
  removeCookie(COOKEY_KEY.ACCESS_TOKEN, {
    domain: 'blockai.kr',
    path: '/',
  });
  removeCookie(COOKEY_KEY.REFRESH_TOKEN, {
    ...createCookieOption(),
  });
};
